export class AuthUserInfoObject {
    email: string;
    firstName: string;
    lastName: string;
    avatar: string;
    uid: string;
    constructor(
        email: string,
        firstName: string,
        lastName: string,
        avatar: string,
        uid: string,
    ) {
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
        this.avatar = avatar;
        this.uid = uid;
    }
}